import { wxChatShare } from "@/common/wechat";
import request from "@/common/request";
// 开州帅视频所有页面微信二次分享信息保持一致
export function setWechatShare() {
  wxChatShare(
    "帅视频",
    "帅视频，让你的视界更帅！",
    window.location.href,
    "https://imagecdn.cqliving.com/images/icon/22.png"
  );
}

// 视频新闻跳转详情
export function commonJumpNewsDetail(item: any) {
  if (typeof item !== "string") {
    if (item.hasOwnProperty("jsonUrl") && item.jsonUrl) {
      request.get(item.jsonUrl).then((res: any) => {
        setTimeout(() => {
          window.open(res.shareData.shareUrl, "_blank");
        });
      });
    } else {
      const env = process.env.NODE_ENV;
      let baseUrl = "";
      let url = "";
      if (env === "pre-release") {
        baseUrl = "https://shareready.cqliving.com";
      } else if (env === "production") {
        baseUrl = "https://share.cqliving.com";
      }
      if (+item.videoFormat === 2) {
        url = `${baseUrl}/news-detail-pages/#/video/vertical-video?appId=22&cid=${item.infoClassifyId}`;
      } else {
        url = item.url;
      }
      setTimeout(() => {
        window.open(url, "_blank");
      });
    }
  } else {
    setTimeout(() => {
      window.open(item, "_blank");
    });
  }
}

export function getFirstLable(str: string) {
  let _str = str.replace(/^,|,$/g, "");
  return _str.split(",")[0];
}
